import React from "react";
import "./header.scss";

const Header = (props) => {
  return (
    <header>
      <nav>
        <div className="container">
          <div className="content">
            <a className="brand" href="https://garj.org">
              <img
                alt=""
                src="https://garj.org/assets/img/logo.png"
              />
              <h1>Global Advanced Research Journals</h1>
            </a>
            <ul>
              <li>
                <a href="https://garj.org">Home</a>
              </li>
              <li>
                <a href="https://garj.org/about">
                  About
                </a>
              </li>
              <li>
                <a href="https://garj.org/journals">
                  Journals
                </a>
              </li>
              <li>
                <a href="https://garj.org/authors-instruction">
                Author's Instruction
                </a>
              </li>
              <li>
                <a href="https://garj.org/call-for-papers">
                  Call For Paper
                </a>
              </li>
              <li>
                <a href="https://garj.org/contact">
                  Contact us
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
